import { gql } from '@apollo/client'

export const AUTHENTICATE_USER_WITH_FACEBOOK = gql`
  mutation authenticateUserWithFacebook($input: AuthenticateFacebookUserInput!) {
    facebookAuth: authenticateUserWithFacebook(input: $input) {
      apiAccessToken {
        tokenString
        expiresAt
      }
      isNew
    }
  }
`
